import { mix } from "@chorda/core";
import * as Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-typescript';
const withHighlight = () => {
    return {
        joints: {
            highlight: ({ $dom }) => {
                $dom.$subscribe((el) => {
                    el && Prism.highlightAllUnder(el);
                    // el && scope.$renderer.addTask(() => {
                    //     Prism.highlightAllUnder(el)
                    // })
                });
            }
        }
    };
};
export const CodeBox = (props) => {
    return mix({
        tag: 'pre',
        templates: {
            content: {
                tag: 'code',
                css: 'language-typescript',
            }
        }
    }, {
        templates: {
            content: {
                text: String(props.code)
            }
        }
    }, withHighlight);
};
